<template>
    <div class="latest-news">
        <header>
            <h1>CHERY INFORMATION</h1>
            <p>Explore the latest news from Chery</p>

            <router-link to="/news" tag="button" class="txt-line">view all</router-link>
        </header>
        <div class="container" ref="track">
            <div class="card" v-for="(x, index) in posts" :key="index" ref="cards">
                <div class="cover"></div>
                <div>
                    <img loading="lazy" :src="x.postImg" alt="news image">
                </div>
                <div>
                    <div class="date">{{ x.date}}</div>
                    <div class="title">{{ x.title_en }}</div>
                    <router-link :to="`/news/${x.slug}`" tag="button" class="txt">explore</router-link>
                </div>
            </div>
        </div>
        <br>
        <div class="controller">
            <span @click="sliderNavigation(0)" :class="{active: activeIndex==0}"></span>
            <span @click="sliderNavigation(1)" :class="{active: activeIndex==1}"></span>
            <span @click="sliderNavigation(2)" :class="{active: activeIndex==2}"></span>
        </div>
    </div>
</template>


<script>
    import api from "@/apis.js";
    export default {
        data() {
            return {
                posts: [],
                activeIndex: 0
            }
        },
        methods: {
            sliderNavigation(index) {
                if (index == 0) {
                    this.$refs.track.style.transform = `translateX(335px)`;
                    this.activeIndex = 0;
                }
                else if (index == 1) {
                    this.$refs.track.style.transform = `translateX(0)`;
                    this.activeIndex = 1;
                }
                else if (index == 2) {
                    this.$refs.track.style.transform = `translateX(-335px)`;
                    this.activeIndex = 2;
                }
            },
            getNews() {
                api.get("/news/latest")
                .then(res => {
                    console.log(res.data);
                    this.posts = res.data;
                })
                .catch(err => {
                    console.log(err)
                })
            }
        },
        mounted() {
            this.getNews();
        }
    }
</script>